import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-direct-debit-dialog',
    templateUrl: './direct-debit-dialog.component.html',
    styleUrls: ['./direct-debit-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class DirectDebitDialogComponent {
  titleClass: string;
  @Output() setUpDirectDebit: EventEmitter<boolean> = new EventEmitter();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>, overlayContainer: OverlayContainer, public breakpointObserver: BreakpointObserver) {
    overlayContainer.getContainerElement().classList.remove('mini-calendar-dialog_overlay');
    overlayContainer.getContainerElement().classList.add('direct-debit-dialog_overlay');
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([
      Breakpoints.Handset,
      Breakpoints.Tablet
    ]).subscribe(result => {
      if (result.matches) {
        this.setMobileLayout();
      } else {
        this.setDesktopLayout();
      }
    });
  }

  setMobileLayout() {
    this.titleClass = 'mat-headline u-margin-bottom-15';
    if (window.innerWidth > 1129 && window.innerWidth < 1360) {
      this.dialogRef.updateSize('450px', 'auto');
    } else {
      this.dialogRef.updateSize('400px', 'auto');
    }
  }

  setDesktopLayout() {
    this.titleClass = 'mat-display-1';
    this.dialogRef.updateSize('550px', 'auto');
  }

  onSetUp(): void {
    this.setUpDirectDebit.emit(true);
    this.dialogRef.close();
  }


}
